/**
 * Synchro complete du poste : catalogue puis liste des employes.
 *
 * Une route du poste qui repond 403 POSTE_DESACTIVE (poste suspendu dans
 * l'ERP) ou POSTE_REVOQUE donne le statut du poste : il est garde dans
 * `meta` (comme le fait le battement de coeur), et RIEN n'est efface : ni
 * catalogue, ni employes, ni jeton, ni cle.
 */
import { saveTerminalStatus } from '../app/enrollment';
import { TERMINAL_STATUS_FOR_CODE, syncCatalog } from './catalogSync';
import { syncRoster } from './rosterSync';

/** Premier statut de poste appris par l'une des synchros, ou null. */
function statusFrom(...results) {
    for (const result of results) {
        if (result && !result.ok && TERMINAL_STATUS_FOR_CODE[result.code]) return TERMINAL_STATUS_FOR_CODE[result.code];
    }
    return null;
}

/**
 * @param {object} options voir syncCatalog ; `catalog: false` pour ne
 *   synchroniser que la liste des employes.
 * @returns {Promise<{ catalog: object|null, roster: object|null, terminalStatus: string|null }>}
 */
export async function syncAll({ db, api, token, storeId, now, subtle, onProgress = () => {}, catalog = true }) {
    const catalogResult = catalog
        ? await syncCatalog({
            db, api, token, storeId, now, subtle,
            onProgress: (p) => onProgress({ ...p, percent: Math.round(p.percent * 0.9) }),
        })
        : null;

    let terminalStatus = statusFrom(catalogResult);
    let rosterResult = null;
    // Poste suspendu, revoque ou inconnu : la liste repondrait de meme.
    if (!terminalStatus) {
        onProgress({ step: 'roster', percent: 92 });
        rosterResult = await syncRoster({ db, api, token, storeId, now });
        terminalStatus = statusFrom(rosterResult);
    }
    if (terminalStatus === 'DISABLED' || terminalStatus === 'REVOKED') {
        await saveTerminalStatus(db, terminalStatus);
    }
    onProgress({ step: 'done', percent: 100 });
    return { catalog: catalogResult, roster: rosterResult, terminalStatus };
}
